import { Field, reduxForm } from "redux-form";
import { UISref } from "@uirouter/react";
import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { FormDropDown, FormRichEditor } from "../Common";
import { defaultNotificationTypes } from "../../helpers/notificationHelpers";
import { required } from "../../helpers/FormField/formFieldHelpers";
import Button from "../Common/Button";

const NotificationForm = ({ handleSubmit, initialValues, isDisabled, onSubmit, isInEditMode }) => {
  const handleSendNotification = values => onSubmit(values);
  const expiresIn = _.range(1, 11).map(value => ({ value, label: `${value} ${i18n.t("notification.days")}` }));

  return (
    <form className="form__container" onSubmit={handleSubmit(handleSendNotification)}>
      <div className="form__row">
        <Field
          component={FormDropDown}
          data={defaultNotificationTypes()}
          name="messageType"
          valueContainerLabel={i18n.t("notification.type")}
          selectClassName="--max"
          validate={[required]}
          disabled={isDisabled}
        />
      </div>

      {!isInEditMode && (
        <div className="form__row">
          <Field
            component={FormDropDown}
            data={expiresIn}
            name="expiresIn"
            valueContainerLabel={i18n.t("notification.expiresIn")}
            selectClassName="--max"
            selectedValue={initialValues.expiresIn}
            disabled={isDisabled}
            noLabel
          />
        </div>
      )}

      <div className="form__row">
        <Field component={FormRichEditor} name="message" validate={[required]} disabled={isDisabled} />
      </div>
      <div className="form__row --centered">
        <UISref to="manage-notifications">
          <Button className="form__button --cancel" label={i18n.t("button.cancel")} disabled={isDisabled} />
        </UISref>
        <Button className="form__button" label={i18n.t("notification.send")} disabled={isDisabled} />
      </div>
    </form>
  );
};

NotificationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  isDisabled: PropTypes.bool,
  isInEditMode: PropTypes.bool
};

NotificationForm.defaultProps = {
  initialValues: {},
  isDisabled: false,
  isInEditMode: false
};

export default reduxForm({ form: "notification-form", enableReinitialize: true })(NotificationForm);



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationForm.js